import useConnectors from "@mirage/service-connectors/useConnectors";
import { useFeatureFlagValueBool } from "@mirage/service-experimentation/useFeatureFlagValue";
import {
  DismissAfterAccountAge,
  useDismissableModule,
} from "@mirage/service-onboarding/useDismissableModule";
import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useMemo } from "react";

const APPS_SYNCING_TOOLTIP_KEY = "dismissedAppsSyncingTooltip";

export const isAddAppsTooltipOpenAtom = atomWithStorage(
  "isAddAppsTooltipOpenAtom",
  false,
);

export const useAppsTooltip = () => {
  const [tooltipOpen, setTooltipOpen] = useAtom(isAddAppsTooltipOpenAtom);
  const dismissBehavior = useMemo(() => new DismissAfterAccountAge("3d"), []);
  const isFeatureEnabled = useFeatureFlagValueBool(
    "dash_growth_2025_06_26_nav_sync_status_indicator",
  );

  const { initialConnectionsAreSyncing } = useConnectors();
  const { dismissed, setDismissed } = useDismissableModule(
    APPS_SYNCING_TOOLTIP_KEY,
    dismissBehavior,
  );

  const openTooltip = () => {
    if (!isFeatureEnabled) {
      return;
    }
    setTooltipOpen(true);
  };

  return {
    dismissed,
    setDismissed,
    initialSync: isFeatureEnabled && initialConnectionsAreSyncing,
    isTooltipOpen: tooltipOpen && !dismissed,
    openTooltip,
  };
};
